import { useEffect, useRef } from "react"

import { useChangeFeed } from "../ChangeFeedProvider.jsx"

/*
 * Subscribe auf Change-Feed-Events nach Entity-Typ. Der Handler liegt in
 * einer Ref: neue Handler-Identitäten führen nicht zu Re-Subscribes.
 * Ohne Provider (Tests, Feature aus) ist der Hook ein No-op.
 */
export default function useEntityChangeSubscription(entityTypes, handler) {
  const feed = useChangeFeed()
  const handlerRef = useRef(handler)
  handlerRef.current = handler

  const typesKey = Array.isArray(entityTypes) ? entityTypes.join(",") : ""

  useEffect(() => {
    if (!feed || !typesKey) return undefined
    return feed.subscribe(typesKey.split(","), (batch) => handlerRef.current?.(batch))
  }, [feed, typesKey])
}
